<template>
  <div class="sale-recovery-filter">
    <bp-checkboxes-dropdown
      v-model="form.product_id"
      masculine
      label="Produto(s)"
      :options="productOptions"
      productsDropdown
    />

    <footer-actions
      class="mt-9"
      label="Aplicar"
      @cancel="close"
      @submit="apply"
    />
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(["product_id", "dates", "search"], {
        ...this.value
      })
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    productOptions() {
      return [...this.products].map(p => ({ ...p, label: p.name }));
    }
  },
  methods: {
    apply() {
      this.$emit("input", this.form);
      this.$emit("close");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
